import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=f1624738&scoped=true"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/inbox.css?vue&type=style&index=0&id=f1624738&prod&scoped=true&lang=css&external"
import style1 from "./Reports.vue?vue&type=style&index=1&id=f1624738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1624738",
  null
  
)

export default component.exports